import { useRoutes } from 'react-router-dom';
import { publicRoutes } from './publicRoutes';
import { protectedRoutes } from './protectedRoutes';

export default function AppRoutes() {
  // Phase 5: Unified route composition for easier maintenance.
  return useRoutes([...protectedRoutes, ...publicRoutes]);
}
